import { API_URL } from '@shared/helpers/env';
export function getBaseURL(path = '') {
  return `${API_URL}${path}`;
}
export function getMediaPbxFilePath(file) {
  const path = `/files/pbx/${file}`;
  return getBaseURL(path);
}

export function getMediaAutoinformerFilePath(file) {
  const path = `/files/informer/${file}`;
  return getBaseURL(path);
}
export function getRecordFilePath(recording) {
  return `https://storage.zorra.com/${recording.client_id}/${recording.file}.mp3`;
}

export function getMediaPredictiveFilePath(client_id,storage_file) {
  return `https://storage.zorra.com/${client_id}/${storage_file}.mp3`;
}
